var content_location = function( $ ) {

	var $form;

	var $select;

	var _init = function() {
		$form = $( '#content-location-form' );

		if ( $form.length > 0 ) {
			$select = $form.find( '#content-location-select' );
			_setup_form_submission();
		}
	};

	var _setup_form_submission = function() {
		$select.on( 'change', _submit );
	};

	var _submit = function (e) {
		var edition = $select.val();

		if (edition === 'us') {
			window.location.href = $form.data( 'amj-url' );
		}

		if (edition === 'european') {
			window.location.href = $form.data( 'emj-url' );
		}
	};

	$( document ).ready( _init );

	return {};

} ( jQuery );

module.exports = content_location;